import React, { useState } from "react";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import MenuItem from "@mui/material/MenuItem";
import DialogComponent from "../../DialogComponent/DialogComponent";
import CustomButton from "../../CustomButton/CustomButton";
import CustomMenu from "../../Menu/CustomMenu";
import loyalty_demo_file from "../../../../assets/demoFile/loyalty-demo-excel.xlsx";
import customer_demo_file from "../../../../assets/demoFile/customer-demo-excel.xlsx";
import supplier_demo_file from "../../../../assets/demoFile/supplier-demo-excel.xlsx";
import { axiosFunction } from "../../../commonFunctions/axiosFunction"; 
import { v2ReactURL } from "../../../../utils/constant";
import { toastMessage } from "../../../commonFunctions/ToasterMessage";
import { SwalFunction } from "../../../commonFunctions/SwalFunction";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import { useSelector } from "react-redux";
import FileUploadDialogue from "../../FileUploadDialogue/FileUploadComponent";


interface ImportExportProps {
  exportData: (filters?: any) => Record<string, any>[];
  exportExcelData: (filters?: any) => Record<string, any> | undefined;
  exportAllData: (data: any[], filters?: any) => any[] | undefined;
  selectedBranch: number[];
  contactType?: string;
  fetchData: () => Promise<void>;
  dynamicMenuAction?: any;
  setIsLoadingExcel: (value: boolean) => void;
  setProgress: React.Dispatch<React.SetStateAction<number>>;
}

interface wrongSheetDTO {
  rowno: number;
  reason: string;
  i : number;
}
// interface ExportColumn  {
//   [key: number]: string;
// }

const ImportExport: React.FC<ImportExportProps> = ({
  exportData,
  exportExcelData,
  dynamicMenuAction,
  fetchData,
  setIsLoadingExcel,
  setProgress
}) => {
  const [openImportDialog, setOpenImportDialog] = useState(false);
  const [forContact, setForContact] = useState<boolean>(true);

  const [isLoading, setIsloading] = useState(false)
  // const sessionList = useSelector((state:any) => state.sessionData.sessionScope);
  const sessionList = useSelector((state: any) => state.sessionData.sessionScope);
    // const sessionBranchId = sessionList?.branchId;
  // const sessionBranchId = sessionList?.branchId;
  const contactPayloadData = useSelector((state:any) => state.contactPayloadData);

  const contactType = useSelector((state:any) => state.contactType);

  const demoFile =
    contactType === "customers" ? customer_demo_file : supplier_demo_file;

  const [file, setFile] = useState<File | string>("");
  const [fileName, setFileName] = useState<string>("");

  const [anchorEl, setAnchorEl] = useState< null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const [fileUploading, setFileUploading] = useState(false);

  const handleClose = () => {
    setAnchorEl(null);
    setFile("" as File | string);
    setFileName("");
  };

  const handleImportExportMenu = (e: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(e.currentTarget);
  };

  const handleOpenImportDialog = (forContact:boolean) => {
    setOpenImportDialog(!openImportDialog);
    setForContact(forContact);
    handleClose();
    setIsloading(false)
  };

  const handleExcelImport = async (contactType: string, isLoyalty: boolean) => {
    setIsloading(true);

    const url = isLoyalty
        ? `${v2ReactURL}/contact/check/excel/loyalty`
        : `${v2ReactURL}/contact/${contactType}/check/excel`;

    const response = await axiosFunction(url, "POST", {excelFile: file}, true);

    setIsloading(false);

    if (!response.data.flag) {
      setFileUploading(false);
      toastMessage(response.data.wrongSheetMSG, "error");
      setFileName("");
      setFile("");
      return;
    }

    if (response.data.totalWrongRows !== 0) {
      if (response.data.totalWrongRows === response.data.totalRows) {
        const wrongDetailsMessage = response.data.wrongSheetDTO
            .map((data: wrongSheetDTO) => `Row: ${data.rowno} - ${data.reason}`)
            .join(", ");

        toastMessage(wrongDetailsMessage, "error");
        setFileName("");
        setFile("");
        return false;
      }

      const message = `${response.data.totalWrongRows} total contact(s) have issues. Do you want to upload the rest?`;
      const result = await SwalFunction(message, "You Won't Be Able To Revert This!", "Yes, Upload It!");

      if (result.isConfirmed) {
        await uploadExcel(response.data.wrongSheetDTO, contactType, isLoyalty, "1");
      }
    } else {
      const result = await SwalFunction(
          "Records are verified, Please proceed to add?",
          "You Won't Be Able To Revert This!",
          "Yes, Upload It!"
      );

      if (result.isConfirmed) {
        await uploadExcel(response.data.wrongSheetDTO, contactType, isLoyalty, "0");
      }
    }
  };

  const uploadExcel = async (
      wrongSheetDTO: wrongSheetDTO[],
      contactType: string,
      isLoyalty: boolean,
      uploadType: string,
  ) => {
    setFileUploading(true);
    setIsloading(true);


    const formData = new FormData();
    file && formData.append("excelFile", file);
    formData.append(
        "wrongSheetDTOS",
        new Blob([JSON.stringify(wrongSheetDTO)], {type: "application/json"})
    );

    const url = isLoyalty
        ? `${v2ReactURL}/contact/upload/excel/loyalty/${uploadType}`
        : `${v2ReactURL}/contact/${contactType}/upload/excel/${uploadType}`;

    const response = await axiosFunction(url, "POST", formData, true, uploadType === "1" ? "blob" : undefined);

    setIsloading(false);


    if (uploadType === "1" && response != null) {
      const blob = new Blob([response.data]);
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.setAttribute("download", isLoyalty ? "bug_loyalty.xlsx" : "bug_contact.xlsx");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(link.href);
    }

    if (response != null && response.status === 200) {
      toastMessage(isLoyalty ? "Loyalty points updated successfully..!" : "Contact imported successfully..!", "success");
      if (fetchData)
        fetchData();
    } else {
      toastMessage("Something went wrong");
    }
    setFileName("");
    setFile("");
    setFileUploading(false);
    setOpenImportDialog(false)

  };

  const handleVerifyBtn = async () => {
     setIsloading(true)
    const response = await axiosFunction(
      `${v2ReactURL}/contact/${contactType}/check/excel`,
      "POST",
      { excelFile: file },
      true
    );
   if(response.data.flag){
    setIsloading(false)
   }
    if (response.data.flag) {

      if (response.data.totalWrongRows !== 0) {
        if (response.data.totalWrongRows === response.data.totalRows) {
          let wrongDetailsMessage = "";

          response.data.wrongSheetDTO.forEach((data : wrongSheetDTO) => {
            wrongDetailsMessage +=
              "Row: " + data.rowno + "-" + data.reason + ",";
          });
          setIsloading(false)
          toastMessage(wrongDetailsMessage, "error");
          setFileName("");
          setFile("");
          return false;
        }

        const message =
          response.data.totalWrongRows +
          " total Contact has issue do you want to upload rest of contact ?";
        const result = await SwalFunction(
          message,
          "You Won't Be Able To Revert This!",
          "Yes, Upload It!"
        );

        if (result.isConfirmed) {
          setIsloading(false)
        //  setFileUploading(true);
        //  toastMessage("Contact imported successfully..!", "success");
         fetchData()
          const formData = new FormData();

          file && formData.append("excelFile", file);
          formData.append(
            "wrongSheetDTOS",
            new Blob([JSON.stringify(response.data.wrongSheetDTO)], {
              type: "application/json",
            })
          );
          toastMessage("Import Started...!", "info");
          setIsloading(true)
          const excelResponse = await axiosFunction(
            `${v2ReactURL}/contact/${contactType}/upload/excel/1`,
            "POST",
            formData,
            true,
            "blob"
          );

          const blob = new Blob([excelResponse.data]);
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;

          link.setAttribute("download", "bug_contact.xlsx");
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);

          // setFileUploading(false);
          setFileName("");
          setFile("");
          fetchData()
          setOpenImportDialog(false)
          setIsloading(false)
        }
      } else {
        setIsloading(false)
        const result = await SwalFunction(
          "Records are verified, Please proceed to add",
          "You Won't Be Able To Revert This!",
          "Yes, Upload It!"
        );

        if (result.isConfirmed) {
          const formData = new FormData();

          file && formData.append("excelFile", file);
          formData.append(
            "wrongSheetDTOS",
            new Blob([JSON.stringify(response.data.wrongSheetDTO)], {
              type: "application/json",
            })
          );
          toastMessage("Import Started...!", "info");
          setIsloading(true)
          const res = await axiosFunction(
            `${v2ReactURL}/contact/${contactType}/upload/excel/0`,
            "POST",
            formData,
            true
          );

          if (res.status === 200) {
            toastMessage("Contact imported successfully..!", "success");
            setFileName("");
            setFile("");
            fetchData()
            setOpenImportDialog(false)
            setIsloading(false)

            // window.location.reload();
          }
        }
      }
    } else {
      setFileUploading(false);
      setIsloading(false)
      // setFileVerifying(false);
      // When data is empty in sheet then flag false and wrong sheet message will be disaplyed...
      toastMessage(response.data.wrongSheetMSG, "error");
      setFileName("");
      setFile("");
    }

    // when flag is false
  };

  const capitalizeFirstChar = (string:string) => {
    if (!string) return string;
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
  };

  const exportDataFileName =
    sessionList?.branchName ||
    sessionList?.UserName ||
    sessionList?.Name ||
    "test";

    const handleExportPDF = async () => {
      setAnchorEl(null);
      const rows = exportData();
 
      const data = rows;
 
      const columns: string[] = [];
 
      data.forEach((obj) => {
          Object.keys(obj).forEach(function (key) {
              if (!columns.includes(key)) {
                  columns.push(key);
              }
          });
      });
 
      // Limit columns to the first 15
      const columnsData = columns.slice(0, 15).map((col) => {
          return {
              header: col,
              dataKey: col,
          };
      });
 
      const doc = new jsPDF({ orientation: "landscape" });
      const pageWidth = doc.internal.pageSize.width; // Get the page width
      const margin = 10; // Set a small margin for left and right
 
      const title = exportDataFileName;
      const subtitle = `${capitalizeFirstChar(contactType)} List`;
 
      // Calculate the available width for the table
      const availableWidth = pageWidth - 2 * margin; // Subtract left and right margins
 
      // Calculate the width for each column dynamically
      const columnWidth = availableWidth / columnsData.length; // Distribute width evenly
 
      doc.autoTable({
          body: data,
          columns: columnsData,
          startY: 40, // Start the table below the title and subtitle
          styles: {
              fontStyle: "bold",
              overflow: "linebreak", // Ensure content breaks to the next line if it's too long
              cellPadding: 2,
              fontSize: 8,
          },
          columnStyles: {
              // Apply dynamic width to all columns
              ...columnsData.reduce((acc: { [key: string]: { cellWidth: number } }, col) => {
                  acc[col.dataKey] = { cellWidth: columnWidth }; // Use dynamic width
                  return acc;
              }, {}),
          },
          margin: {
              top: 35,
              left: margin, // Use the defined margin
              right: margin, // Use the defined margin
          },
          didDrawPage: () => {
              doc.setFontSize(16);
              doc.setFont("helvetica", "normal");
 
              // Calculate the center position for the title
              const titleWidth = doc.getTextWidth(title);
              doc.text(title, (pageWidth - titleWidth) / 2, 20);
 
              doc.setFontSize(12);
              doc.setFont("helvetica", "normal");
 
              // Calculate the center position for the subtitle
              const subtitleWidth = doc.getTextWidth(subtitle);
              doc.text(subtitle, (pageWidth - subtitleWidth) / 2, 30);
          },
      });
 
      doc.save(`${exportDataFileName}.pdf`);
  };
 

  const handleExportExcel = async () => {
    setAnchorEl(null);

    const data = exportExcelData();
    const keysString = data ? Object.keys(data).join(", ") : "";
    const valuesString = data ? Object.values(data).join(", ") : "";

    const payloadData = {
      ...contactPayloadData,
      columns: keysString,
      queryColumns: valuesString,
    };
    setIsLoadingExcel(true)
    setProgress(0); 
    const res = await axiosFunction(
      `${v2ReactURL}/contact/generate-excel/${contactType}`,
      "POST",
      payloadData,
      false,
      "blob"
    );

    const blob = new Blob([res.data]);
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `${exportDataFileName}.xlsx`);
    setIsLoadingExcel(true)
    document.body.appendChild(link);
    link.click();
    setProgress(100); 
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  };
  const handleAllDataExportExcel = async () => {
    setAnchorEl(null);

    setProgress(0); // Start progress at 0%
    setIsLoadingExcel(true);

    const data = exportExcelData();
    // setProgress(20); // Progress after fetching export data

    const keysString = data ? Object.keys(data).join(", ") : "";
    const valuesString = data ? Object.values(data).join(", ") : "";

    const payloadData = {
        ...contactPayloadData,
        columns: keysString,
        queryColumns: valuesString,
        length: -1,
        start: 0,
    };
    
    setProgress(0); // Progress after preparing payload data

    try {
        const res = await axiosFunction(
            `${v2ReactURL}/contact/generate-excel/${contactType}`,
            "POST",
            payloadData,
            false,
            "blob"
        );
        const blob = new Blob([res.data]);
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${exportDataFileName}.xlsx`);
        document.body.appendChild(link);
        setProgress(90);
        link.click();
         document.body.removeChild(link);
        setProgress(99);
        window.URL.revokeObjectURL(url);
        setProgress(100);
    } catch (error) {
        console.error("Error exporting Excel file:", error);
        setProgress(0); // Reset progress on error
        setIsLoadingExcel(false);
    }
};


  
  const menuFontStyle = { fontFamily: '"Plus Jakarta Sans", sans-serif' };
  // console.log("dynamicMenuActiondsfsdfsd--->>>522552555",dynamicMenuAction)
  const menuItems = () => {
    return (
      <>
        {contactType !== "transport" && (
          <MenuItem sx={menuFontStyle} onClick={()=>handleOpenImportDialog(true)}>
            Import
          </MenuItem>
        )}
        {Boolean(dynamicMenuAction?.Edit) && contactType === "customers" && (sessionList.companyId == sessionList.branchId) && Boolean(dynamicMenuAction?.loyalty) && (
            <MenuItem sx={menuFontStyle} onClick={()=> handleOpenImportDialog(false)}>
              Import Loyalty
            </MenuItem>
        )}
        <MenuItem sx={menuFontStyle} onClick={handleExportPDF}>
          Export PDF
        </MenuItem>
        <MenuItem sx={menuFontStyle} onClick={handleExportExcel}>
          Export Excel
        </MenuItem>
        <MenuItem sx={menuFontStyle} onClick={handleAllDataExportExcel}>
          All Data Excel
        </MenuItem>
        {/* <MenuItem sx={menuFontStyle} onClick={handleAllDataExportPDF}>
          All Data PDF
        </MenuItem> */}
      </>
    );
  };

  return (
    <>
      <CustomButton
        open={open}
        onClick={handleImportExportMenu}
        iconComponent={<InsertDriveFileIcon sx={{ fontSize: "16px" }} />}
        btnName={contactType !== "transport" ? "Import/Export" : "Export"}
      />
      <CustomMenu
        menuItems={menuItems()}
        openMenu={open}
        handleClose={handleClose}
        anchorEl={anchorEl}
      />

      <DialogComponent
        isLoading={isLoading}
        handleClose={() => setOpenImportDialog(!openImportDialog)}
        dialogTitle={"Upload Sheet"}
        openDialog={openImportDialog}
        dialogContent={
          <FileUploadDialogue
            demoFile={forContact ? demoFile : loyalty_demo_file}
            fileName={fileName}
            setFile={setFile}
            setFileName={setFileName}
            sheetImporting={true}
          />
        }
        handleSubmitBtn={() => forContact ? handleVerifyBtn(): handleExcelImport("", true)}
        disabledSubmitBtn={!file}
        loading={fileUploading}
      />
    </>
  );
};

export default ImportExport;
